"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class FeatureFlagClient extends authenticated_client_1.AuthenticatedClient {
    getProjectFlags(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/feature-flags/projects/${projectId}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getAccountFlags(accountId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/feature-flags/accounts/${accountId}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getAccountsFlags(accountIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/feature-flags/accounts`;
            const response = yield this.httpPost(url, { accountIds });
            return response.payload;
        });
    }
    getAccountProjectsFlags(accountId, projectIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/feature-flags/accounts/${accountId}/projects`;
            const response = yield this.httpPost(url, { projectIds });
            return response.payload;
        });
    }
    getMyFlags() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/feature-flags/me`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getGeneralAvailabilityFeatures() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `v1/feature-flags/general-availability`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.FeatureFlagClient = FeatureFlagClient;
//# sourceMappingURL=feature-flag.client.js.map